import { Model, type ModelProps } from '@/infra/model'
import { computed, observable } from 'mobx'
import type { SupportingItemInputBase } from '../supporting-item-input'
import { toStream } from '@/utils/mobx-util'

/**
 * Props for {@link SpousalInfoSupportingItemInput}.
 */
export type SpousalInfoSupportingItemInputProps =
  ModelProps<SpousalInfoSupportingItemInput> & { type: 'SpousalInfo' }

/**
 * Supporting item input for spousal information.
 */
export class SpousalInfoSupportingItemInput
  extends Model<SpousalInfoSupportingItemInput>
  implements SupportingItemInputBase
{
  /**
   * The provided spousal profile, if any.
   */
  @observable.struct accessor provided: ProvidedSpousalProfile | null = null

  /**
   * Stream of changes to the provided spousal profile.
   */
  readonly providedChanges$ = toStream(() => this.provided)

  /** @inheritDoc */
  @computed get isCompleted() {
    return !!this.provided
  }
}

/**
 * A provided spousal profile.
 */
export interface ProvidedSpousalProfile {
  readonly profileId: string
  readonly profileVersion: number
}
